export default __webpack_public_path__ + "static/media/BackgroundCard1.55c062c0.png";